import React from 'react';

export const FdicTopBar = () => (
  <div className="bg-[#1a1a1a] text-white">
    <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-4">
      <div className="flex flex-col leading-none">
        <span className="text-[22px] font-black tracking-tight">FDIC</span>
        <span className="text-[8px] tracking-[0.15em] text-white/70">
          FEDERAL DEPOSIT INSURANCE CORPORATION
        </span>
      </div>
      <span className="hidden sm:block text-[9px] tracking-[0.15em] text-white/50 border-l border-white/20 pl-4">
        INSURED INSTITUTION PORTAL
      </span>
    </div>
    <div className="max-w-3xl mx-auto px-4 pb-2 flex gap-6 text-[10px] tracking-[0.18em] text-white/70 uppercase">
      <a href="#" className="hover:text-white">About</a>
      <a href="#" className="hover:text-white">Resources</a>
      <a href="#" className="hover:text-white">Analysis</a>
      <a href="#" className="hover:text-white">News</a>
    </div>
  </div>
);

export const GovBanner = () => (
  <div className="bg-gray-100 border-b border-gray-200 text-[12px] text-gray-700">
    <div className="max-w-3xl mx-auto px-4 py-2 flex items-center gap-2">
      <span aria-hidden="true">🇺🇸</span>
      <span>An official website of the United States government</span>
    </div>
  </div>
);

export const FdicHeader = () => (
  <header className="bg-[#0b2740] text-white">
    <div className="max-w-3xl mx-auto px-4 py-4">
      <div className="flex flex-col leading-none">
        <span className="text-[34px] font-black tracking-tight">FDIC</span>
        <span className="text-[9px] tracking-[0.15em] text-white/70 mt-1">
          FEDERAL DEPOSIT INSURANCE CORPORATION
        </span>
        <span className="text-[8px] tracking-[0.15em] text-white/50 mt-0.5">
          INSURED INSTITUTION PORTAL
        </span>
      </div>
    </div>
    <div className="max-w-3xl mx-auto px-4 pb-3 flex gap-6 text-[11px] tracking-[0.18em] text-white/80 uppercase border-t border-white/10 pt-3">
      <a href="#" className="hover:text-white">About</a>
      <a href="#" className="hover:text-white">Resources</a>
      <a href="#" className="hover:text-white">Analysis</a>
      <a href="#" className="hover:text-white">News</a>
    </div>
  </header>
);

export const FdicFooter = () => (
  <footer className="bg-[#0b2740] text-white mt-auto">
    <div className="max-w-3xl mx-auto px-4 py-6 text-center">
      <p className="text-[11px] text-white/70 leading-5">
        Federal Deposit Insurance Corporation — 550 17th Street NW, Washington, D.C. 20429
      </p>
      <div className="mt-3 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[11px] tracking-[0.1em] text-white/70">
        <a href="#" className="hover:text-white">FDIC.gov</a>
        <a href="#" className="hover:text-white">Contact the FDIC</a>
        <a href="#" className="hover:text-white">FOIA</a>
        <a href="#" className="hover:text-white">Privacy Policy</a>
        <a href="#" className="hover:text-white">Accessibility</a>
      </div>
    </div>
  </footer>
);

export const WizardCard = ({ headerIcon, headerLabel, children }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
    <div className="bg-[#0b2740] text-white px-5 py-4 flex items-center gap-3">
      {headerIcon}
      <span className="text-[12px] font-semibold tracking-[0.2em] uppercase">
        {headerLabel}
      </span>
    </div>
    {children}
  </div>
);